import { render, staticRenderFns } from "./DadosGeraisView.vue?vue&type=template&id=717ce5cc"
import script from "./DadosGeraisView.vue?vue&type=script&lang=js"
export * from "./DadosGeraisView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports